import { useNavigate } from 'react-router-dom';

import { Header } from '../components/index.jsx';
import { DevicesLocations } from '../components/Devices/index.jsx';
import { BreakpointMobile, PathnamesMap } from '../constants/ui';
import { useViewport } from '../hooks';
import { useTranslation } from 'react-i18next';

const LocationsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { widthViewport } = useViewport();

  const handleBack = () => {
    navigate(`/${PathnamesMap.devices}`);
  };

  return (
    <>
      {widthViewport > BreakpointMobile && (
        <Header title={t('locations.titlePrevious')} withBackButton={true} onBackButton={() => handleBack()} t={t} />
      )}
      <main className="main">
        <DevicesLocations t={t} />
      </main>
    </>
  );
};

export default LocationsPage;
